"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageLoader = void 0;
var StorageLoaderBase_1 = require("./StorageLoaderBase");
var LocalStorageLoader = /** @class */ (function (_super) {
    __extends(LocalStorageLoader, _super);
    function LocalStorageLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Clears data stored in the browser localStorage.
     */
    LocalStorageLoader.prototype.ClearStorage = function () {
        try {
            localStorage.removeItem(this.storageKey);
        }
        catch (ex) {
            this.logger.error(ex);
        }
    };
    /**
     * Loads data stored in the browser localStorage.
     *
     * @throws SecurityError exception if localStorage is disabled.
     */
    LocalStorageLoader.prototype.LoadStorage = function () {
        var storedAlmeSession = localStorage.getItem(this.storageKey);
        if (storedAlmeSession) {
            return JSON.parse(atob(storedAlmeSession));
        }
        else {
            return null;
        }
    };
    /**
     * Returns data stored in the browser localStorage.
     *
     * @throws SecurityError exception if localStorage is disabled.
     */
    LocalStorageLoader.prototype.GetStorage = function () {
        return this.LoadStorage();
    };
    /**
     * Updates data stored in the browser localStorage.
     *
     * @throws Throws a "QuotaExceededError" DOMException exception if the new value couldn't be set.
     * (Setting could fail if, e.g., the user has disabled storage for the site, or if the quota has been exceeded.)
     */
    LocalStorageLoader.prototype.UpdateStorage = function (data) {
        localStorage.setItem(this.storageKey, btoa(JSON.stringify(data)));
        return this.GetStorage();
    };
    return LocalStorageLoader;
}(StorageLoaderBase_1.StorageLoaderBase));
exports.LocalStorageLoader = LocalStorageLoader;
//# sourceMappingURL=LocalStorageLoader.js.map